/**
 * Base and Form custom props
 */

// id will be placed manually depending the component has an input override
// className may be cusom on each component
// aria-attr will be placed manually depending the component has an input override
export const getBaseCustomProps = (props: any) => {
	return {
		//key: props['root-key'],
		//ref: props['root-ref'],
		//title: props['root-title'],
		role: props['root-role'],
		tabIndex: props['root-tabindex'],
		...props['root-props'],
	};
};

export const getFormCustomProps = (props: any) => {
	return {
		//name: props.name,
		// tabIndex: props.tabIndex || 0,
		...props['input-props'],
	};
};

// id will be placed manually depending the component has an input override
// aria-attr will be placed manually depending the component has an input override
export const getStorybookBaseTableConfig = {
	className: { table: { disable: true } },
	//'root-key': { table: { category: 'Root item properties' } },
	'root-ref': { table: { category: 'Root item properties' } },
	'root-role': { table: { category: 'Root item properties' } },
	//'root-title': { table: { category: 'Root item properties' } },
	'root-tabindex': { table: { category: 'Root item properties' } },
	'root-props': { table: { category: 'Root item properties' } },
};

export const getStorybookFormTableConfig = {
	name: { table: { disable: true } },
	tabIndex: { table: { category: 'Input item properties' } },
	'input-props': { table: { category: 'Input item properties' } },
};

export interface BaseCustomProps {
	/**
	 * Sets the id attribute to the root or the main interactive element (if it exists)
	 */
	id?: string;
	/**
	 * Sets the key property to the root element of the component
	 */
	//'root-key'?: React.Key | number;
	/**
	 * A reference to access the root element of the component
	 */
	'root-ref'?: any;
	/**
	 * Sets the title attribute to the root element of the component
	 */
	//'root-title'?: string;
	/**
	 * Sets the class property to the root element of the component
	 */
	className?: string;
	/**
	 * Sets the role attribute to the root element of the component
	 */
	'root-role'?: string;
	/**
	 * Sets the ref attribute to the root element of the component
	 */
	'root-tabindex'?: any; // there are some incomaptibilities number | string
	/**
	 * Object for adding properties
	 */
	'root-props'?: object;
}

export interface BaseCustomFormProps extends BaseCustomProps {
	/**
	 * Sets the name attribute
	 */
	name?: string;
	/**
	 * Sets the tabindex attribute
	 */
	tabIndex?: any; // there are some incomaptibilities number | string
	/**
	 * Object for adding properties into the input element
	 */
	'input-props'?: object;
}

export interface IOpenInterface {
	//	[index: string]: any;
}

export type colourPalette =
"red-50" |
"red-100" |
"red-200" |
"red-300" |
"red-400" |
"red-500" |
"red-600" |
"red-700" |
"red-800" |
"red-900" |
"red-a-100" |
"red-a-200" |
"red-a-400" |
"red-a-700" |
"pink-50" |
"pink-100" |
"pink-200" |
"pink-300" |
"pink-400" |
"pink-500" |
"pink-600" |
"pink-700" |
"pink-800" |
"pink-900" |
"pink-a-100" |
"pink-a-200" |
"pink-a-400" |
"pink-a-700" |
"purple-50" |
"purple-100" |
"purple-200" |
"purple-300" |
"purple-400" |
"purple-500" |
"purple-600" |
"purple-700" |
"purple-800" |
"purple-900" |
"purple-a-100" |
"purple-a-200" |
"purple-a-400" |
"purple-a-700" |
"deeppurple-50" |
"deeppurple-100" |
"deeppurple-200" |
"deeppurple-300" |
"deeppurple-400" |
"deeppurple-500" |
"deeppurple-600" |
"deeppurple-700" |
"deeppurple-800" |
"deeppurple-900" |
"deeppurple-a-100" |
"deeppurple-a-200" |
"deeppurple-a-400" |
"deeppurple-a-700" |
"indigo-50" |
"indigo-100" |
"indigo-200" |
"indigo-300" |
"indigo-400" |
"indigo-500" |
"indigo-600" |
"indigo-700" |
"indigo-800" |
"indigo-900" |
"indigo-a-100" |
"indigo-a-200" |
"indigo-a-400" |
"indigo-a-700" |
"blue-50" |
"blue-100" |
"blue-200" |
"blue-300" |
"blue-400" |
"blue-500" |
"blue-600" |
"blue-700" |
"blue-800" |
"blue-900" |
"blue-a-100" |
"blue-a-200" |
"blue-a-400" |
"blue-a-700" |
"lightblue-50" |
"lightblue-100" |
"lightblue-200" |
"lightblue-300" |
"lightblue-400" |
"lightblue-500" |
"lightblue-600" |
"lightblue-700" |
"lightblue-800" |
"lightblue-900" |
"lightblue-a-100" |
"lightblue-a-200" |
"lightblue-a-400" |
"lightblue-a-700" |
"cyan-50" |
"cyan-100" |
"cyan-200" |
"cyan-300" |
"cyan-400" |
"cyan-500" |
"cyan-600" |
"cyan-700" |
"cyan-800" |
"cyan-900" |
"cyan-a-100" |
"cyan-a-200" |
"cyan-a-400" |
"cyan-a-700" |
"teal-50" |
"teal-100" |
"teal-200" |
"teal-300" |
"teal-400" |
"teal-500" |
"teal-600" |
"teal-700" |
"teal-800" |
"teal-900" |
"teal-a-100" |
"teal-a-200" |
"teal-a-400" |
"teal-a-700" |
"green-50" |
"green-100" |
"green-200" |
"green-300" |
"green-400" |
"green-500" |
"green-600" |
"green-700" |
"green-800" |
"green-900" |
"green-a-100" |
"green-a-200" |
"green-a-400" |
"green-a-700" |
"lightgreen-50" |
"lightgreen-100" |
"lightgreen-200" |
"lightgreen-300" |
"lightgreen-400" |
"lightgreen-500" |
"lightgreen-600" |
"lightgreen-700" |
"lightgreen-800" |
"lightgreen-900" |
"lightgreen-a-100" |
"lightgreen-a-200" |
"lightgreen-a-400" |
"lightgreen-a-700" |
"lime-50" |
"lime-100" |
"lime-200" |
"lime-300" |
"lime-400" |
"lime-500" |
"lime-600" |
"lime-700" |
"lime-800" |
"lime-900" |
"lime-a-100" |
"lime-a-200" |
"lime-a-400" |
"lime-a-700" |
"yellow-50" |
"yellow-100" |
"yellow-200" |
"yellow-300" |
"yellow-400" |
"yellow-500" |
"yellow-600" |
"yellow-700" |
"yellow-800" |
"yellow-900" |
"yellow-a-100" |
"yellow-a-200" |
"yellow-a-400" |
"yellow-a-700" |
"amber-50" |
"amber-100" |
"amber-200" |
"amber-300" |
"amber-400" |
"amber-500" |
"amber-600" |
"amber-700" |
"amber-800" |
"amber-900" |
"amber-a-100" |
"amber-a-200" |
"amber-a-400" |
"amber-a-700" |
"orange-50" |
"orange-100" |
"orange-200" |
"orange-300" |
"orange-400" |
"orange-500" |
"orange-600" |
"orange-700" |
"orange-800" |
"orange-900" |
"orange-a-100" |
"orange-a-200" |
"orange-a-400" |
"orange-a-700" |
"deeporange-50" |
"deeporange-100" |
"deeporange-200" |
"deeporange-300" |
"deeporange-400" |
"deeporange-500" |
"deeporange-600" |
"deeporange-700" |
"deeporange-800" |
"deeporange-900" |
"deeporange-a-100" |
"deeporange-a-200" |
"deeporange-a-400" |
"deeporange-a-700" |
"brown-50" |
"brown-100" |
"brown-200" |
"brown-300" |
"brown-400" |
"brown-500" |
"brown-600" |
"brown-700" |
"brown-800" |
"brown-900" |
"grey-0" |
"grey-50" |
"grey-100" |
"grey-200" |
"grey-300" |
"grey-400" |
"grey-500" |
"grey-600" |
"grey-700" |
"grey-800" |
"grey-900" |
"grey-950" |
"grey-1000" |
"bluegrey-50" |
"bluegrey-100" |
"bluegrey-200" |
"bluegrey-300" |
"bluegrey-400" |
"bluegrey-500" |
"bluegrey-600" |
"bluegrey-700" |
"bluegrey-800" |
"bluegrey-900" 


export interface SpacingProp {
	spacing?:
		| 'm-0'
		| 'm-xs'
		| 'm-s'
		| 'm-m'
		| 'm-l'
		| 'm-xl'
		| 'm-auto'
		| 'mx-0'
		| 'mx-xs'
		| 'mx-s'
		| 'mx-m'
		| 'mx-l'
		| 'mx-xl'
		| 'mx-auto'
		| 'my-0'
		| 'my-xs'
		| 'my-s'
		| 'my-m'
		| 'my-l'
		| 'my-xl'
		| 'my-auto'
		| 'mt-0'
		| 'mt-xs'
		| 'mt-s'
		| 'mt-m'
		| 'mt-l'
		| 'mt-xl'
		| 'mt-auto'
		| 'mr-0'
		| 'mr-xs'
		| 'mr-s'
		| 'mr-m'
		| 'mr-l'
		| 'mr-xl'
		| 'mr-auto'
		| 'mb-0'
		| 'mb-xs'
		| 'mb-s'
		| 'mb-m'
		| 'mb-l'
		| 'mb-xl'
		| 'mb-auto'
		| 'ml-0'
		| 'ml-xs'
		| 'ml-s'
		| 'ml-m'
		| 'ml-l'
		| 'ml-xl'
		| 'ml-auto'
		| 'm-n-xs'
		| 'm-n-s'
		| 'm-n-m'
		| 'm-n-l'
		| 'm-n-xl'
		| 'mx-n-xs'
		| 'mx-n-s'
		| 'mx-n-m'
		| 'mx-n-l'
		| 'mx-n-xl'
		| 'my-n-xs'
		| 'my-n-s'
		| 'my-n-m'
		| 'my-n-l'
		| 'my-n-xl'
		| 'mt-n-xs'
		| 'mt-n-s'
		| 'mt-n-m'
		| 'mt-n-l'
		| 'mt-n-xl'
		| 'mr-n-xs'
		| 'mr-n-s'
		| 'mr-n-m'
		| 'mr-n-l'
		| 'mr-n-xl'
		| 'mb-n-xs'
		| 'mb-n-s'
		| 'mb-n-m'
		| 'mb-n-l'
		| 'mb-n-xl'
		| 'ml-n-xs'
		| 'ml-n-s'
		| 'ml-n-m'
		| 'ml-n-l'
		| 'ml-n-xl';
}
